import { HomeComponent } from "./components/home/home.component";
import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { pageRoute } from "./constant/pageRoute";
import { LoginComponent } from "./components/security/login/login.component";
import { AuthGuard } from "./service/components/authentication/guards/auth.guard";
import { RoleManagerComponent } from "./components/role-manager/role-manager.component";
import { UserManageComponent } from "./components/jubili/usermanage/user-manage.component"
import { CompanyManageComponent } from "./components/jubili/company/company-manage.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: pageRoute.login,
    pathMatch: "full"
  },
  {
    path: pageRoute.login,
    component: LoginComponent,
    data: { title: "Login" }
  },
  {
    path: pageRoute.home,
    component: HomeComponent,
    data: { title: "Home" },
    canActivate: [AuthGuard]
  },
  {
    path: pageRoute.rolemanager,
    component: RoleManagerComponent,
    data: { title: "Role Manager" }
  },
  {
    path: pageRoute.intake,
    loadChildren: "./components/intake/intake.module#IntakeModule",
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
